import { LOCALES } from '../constants';

export default {
    [LOCALES.JAPANESE]: {
        //Menu
        'Menu-Top': 'ホーム',
        'Menu-ChangePassword': 'ログインパスワード変更',
        'Menu-ExchangeRate': "通貨レート",
        'Menu-SupervisorList': 'スーパーバイザー一覧',
        'Menu-SupervisorAdd': 'スーパーバイザー追加',
        'Menu-AdminList': '管理者一覧',
        'Menu-AdminAdd': '管理者追加',
        'Menu-TransactionList': '取引履歴',
        'Menu-TransactionDetails': '取引詳細',
        'Menu-ExecutionList': '決済取引履歴',
        'Menu-OtcSell': 'OTC 売',
        'Menu-DepositWithdraw': '入出金',
        'Menu-DepositWithdrawList': '入出金履歴',
        'Menu-DepositWithdrawDetails': '入出金詳細',
        'Menu-DepositList': '入金処理',
        'Menu-DepositModify': '入金変更',
        'Menu-DepositAdd': '入金追加',
        'Menu-DepositImport': '入金インポート',
        'Menu-WithdrawList': '出金処理',
        'Menu-WithdrawModify': '出金変更',
        'Menu-UserBalanceList': '口座残高',
        'Menu-ClientList': 'CASP一覧',
        'Menu-ClientModify': 'CASP変更',
        'Menu-TrancheList': 'トランシェ一覧',
        'Menu-TrancheAdd': 'トランシェ追加',
        'Menu-TrancheModify': 'トランシェ変更',
        'Menu-AgathaConfiguration': 'AGATHA 設定',
        'Menu-User': 'ユーザー',
        'Menu-UserList': 'ユーザー一覧',
        'Menu-UserDetailsList': 'ユーザー詳細一覧',
        'Menu-UserModify': 'ユーザー変更',
        'Menu-UserDetailsModify': 'ユーザー変更',
        'Menu-UserChangeRequestList': '変更届け一覧',
        'Menu-UserChangeRequestModify': '変更届け',
        'Menu-PromoterList': 'Progress Associator List',
        'Menu-PromoterModify': 'Modify Progress Associator',
        'Menu-UserInfoRequestList': 'ユーザー情報リクエスト一覧',
        'Menu-UserInfoRequestModify': 'ユーザー情報リクエスト変更',
        'Menu-Log': 'ログ',
        'Menu-UserLoginList': 'ユーザーログイン',
        'Menu-AdminLoginList': '管理者ログイン',
        'Menu-AdminActionLogList': '管理者アクションログ',
        'Menu-AdminActionLog': '管理者アクションログ',
        'Menu-CommissionRate': '手数料設定',
        'Menu-Trading': '取引',
        'Menu-Account': 'アカウント管理',
        'Menu-AccessRights': 'アクセス権',
        'Menu-AdminAccessRights': '管理者アクセス権',
        'Menu-DefaultAccessRights': 'デフォルトアクセス権',
        'Menu-CASPAccessRights': 'CASPアクセス権',
        'Menu-SupervisorAccessRights': 'スーパーバイザーアクセス権',
        'Menu-SettlementTransactionList': '決済取引一覧',
        'Menu-CancelRefundList': 'キャンセル返金一覧',
        'Menu-CancelRefundModify': 'キャンセル返金変更',
        'Menu-UserBlockList': 'ブロックリスト一覧',
        'Menu-UserBlockListAdd': 'ブロックリスト追加',
        'Menu-UserBlockListModify': 'ブロックリスト変更',
        'Menu-SupervisorLoginList': '管理者ログイン',
        'Menu-SupervisorActionLogList': '管理者アクションログ',
        'Menu-SupervisorActionLog': '管理者アクションログ',
        'Menu-IssuerConfiguration': 'Issuer 設定',

        //Login
        'Email-Address': 'メールアドレス',
        'Password': 'パスワード',
        'Logout': 'ログアウト',
        'Home': 'ホーム',
        'OTP': 'ワンタイムパスワード',
        'MFASetup-Message': 'Download Google Authenticator App on your Android or IOS device and install. Once installed scan the below code.',
        //Password Change
        'Old-Password': '旧パスワード',
        'New-Password': '新パスワード',
        'Confirm-Password': '新パスワード再入力',
        'password-eligibility-message': 'パスワードは最低１０文字以上で、アルファベット小文字、大文字、数字、特殊文字が最低1つ以上含まれる必要があります。パスワードにはユーザー名や一般的な単語を含めることはできません。',
        'Password-Expired-Message': 'ログインパスワードの有効期限が切れているため、変更する必要があります。',
        'Password-Change-Success-Message1': 'ログインパスワードが変更されました。',
        'Password-Change-Success-Message2': '続行するにはここをクリックしてください。',
        //Currency
        'Agatha': 'AGATHA',
        'Euro': 'EUR',
        'Bitcoin': 'BTC',
        'Euro-Agatha': 'EUR／AGATHA',
        'Bitcoin-Agatha': 'BTC／AGATHA',
        //Button
        'btnUpdate': '更新',
        'btnSearch': '検索',
        'btnAddNew': '追加',
        'btnImport': 'インポート',
        'btnGoToDepositProcess': '入金処理へ',
        'btnBack': '戻る',
        'btnClear': 'クリア',
        'btnSuspiciousTransaction': '疑わしい取引',
        'btnViewUserDetails': 'ユーザー詳細を表示',
        'btnSubmit': '確定',
        'btnVerify': '確認',
        'btnApprove': '承認',
        'btnCancel': 'キャンセル',
        //Others
        'Update-Success-Message': '正常に更新されました',
        'Status-Active': 'アクティブ',
        'Status-InActive': '非活性',
        'Comments': 'コメント',
        'Days': '日数',
        'CreatedByUser': '作成者',
        'VerifiedDate': '確認日',
        'VerifiedByUser': '確認者',
        'ApprovedDate': '承認日',
        'ApprovedByUser': '承認者',
        //Search    
        'Filters': 'フィルター',
        'Search-All': '全て',
        'SearchField': '検索フィールド',
        'Select-SearchField': '検索フィールドを選択',
        'SearchKeyword': '検索キーワード',
        'Search-CASPID': 'CASP ID',
        'Search-UserType': 'ユーザータイプ',
        'Search-KycStatus': 'KYC ステータス',
        'Search-DateFrom': '開始日',
        'Search-DateTo': '終了日',
        'Search-ProcessStatus': 'ステータスを選択',
        'Search-BuySell': '買売区分',
        'Search-OTC': 'OTC',
        'Search-TransactionStatus': '取引状況',
        'Search-Quantity': '数量',
        'Search-Currency': '通貨',
        'Search-TransactionType': '入出金区分',
        'Search-CASP': 'CASP',
        'Search-SelectCASP': 'Select CASP',
        'Search-SelectPaymentType': '支払方法を選択',
		'Search-Suspicious': '疑わしい取引',
        //Home
        'MarketPrice': '市場価格',
        'Symbol': '製品',
        'LastPrice': '最終',
        'Date-MLT': '日時（MLT）',
        'HighPrice': '高価格',
        'LowPrice': '低価格',
        'CustomerSignups': '顧客登録：',
        'Weekly': '毎週',
        'Monthly': '月次',
        'Yearly': '年間',
        'KYCApplications': 'KYC処理：',
        'KycCompleted': 'KYC完了',
        'KycPending': 'KYC保留中',
        'KycRejected': 'KYC拒否',
        'DepositWithdrawRequest': '入出金依頼：',
        'IVFAOBuy': 'IVFAO買：',
        'RecentExecutions': '決済取引履歴：',
        'TopAgathaBalance': 'AGATHA残高：',
        'TopEuroBalance': 'ユーロ残高：',
        'TopBitcoinBalance': 'ビットコイン残高：',
        //CASP
        'RepresentativeName': '代表者名',
        'RepresentativeMailID': '代表者メール',
        'RepresentativePhoneNumber': '代表者電話番号',
        'UserLogin': 'ユーザーログイン',
        'AdminLogin': '管理者ログイン',
        'UserPasswordExpiryDays': 'ユーザーパスワードの有効期限',
        'AdminPasswordExpiryDays': '管理者パスワードの有効期限',
        'SupervisorPasswordExpiryDays': '管理者パスワードの有効期限',
        'AutoBuyBackDays': '自動買戻',
        'AutoCancel': '自動キャンセル',
        //Admin List
        'AdminID': '管理者ID',
        'MailID': 'メールアドレス',
        'AdminName': '管理者名',
        'Status': 'ステータス',
        'AdminRole': 'ロール',
        'CreatedDate': '作成日',
        //User List
        'ClientID': 'CASP ID',
        'UserID': 'ユーザーID',
        'UserType': 'ユーザータイプ',
        'User': '普通',
        'Promoter': 'プログレス アソシエーター',
        'Distributor': 'アソシエーター',
        'ReferredUser': '紹介ユーザー',
        'UserName': 'ユーザー名',
        'Gender': '性別',
        'PhoneNumber': '電話番号',
        'DOB': '生年月日',
        'Reason': 'コメント',
        'UserStatus': 'ステータス',
        'FounderAccount': 'Founder Account',
        //User Details
        'FirstNameJP': '名（漢字）',
        'LastNameJP': '姓（漢字）',
        'Nationality': '国籍',
        'Address1': '住所　ローマ字　（都道府県、市区町村）',
        'Address2': '住所　ローマ字　（町名番地、建物名、号室）',
        'Address1JP': '漢字住所（都道府県、市区町村）',
        'Address2JP': '漢字住所（町名番地、建物名、号室）',
        'ZipCode': '郵便番号',
        'Country': '居住国',
        'Passport': 'パスポート',
        'PassportImage': 'パスポート',
        'PassportBack': 'パスポート裏面',
        'PassportNumber': 'パスポート番号',
        'PassportExpiryDate': 'パスポート有効期限',
        'NationalID': 'マイナンバーカード',
        'NationalIDBack': 'マイナンバーカード裏面',
        'NationalIDExpiryDate': 'マイナンバーカード有効期限',
        'NationalIDNumber': '番号',
        'DriversLicense': '運転免許証',
        'DriversLicenseBack': '運転免許証裏面',
        'LicenseExpiryDate': '運転免許証有効期限',
        'LicenseNumber': '運転免許証番号',
        'Photo1': '正面からの写真',
        'Photo2': '斜め前からの写真',
        'KycStatus': 'KYCステータス',
        'KycValidationStatus': 'KYC検証ステータス',
        'KycValidationError': 'KYC検証エラー',
        'Remarks': '備考',
        'KycApprovedUser': 'KYC承認者',
        'UpdatedByUser': '更新者',
        'Recommender': 'Recommender',
        'Coupon': 'Coupon',
        //Change Request
        'FieldName': 'フィールド名',
        'OldValue': '古い値',
        'NewValue': '新しい値',
        'RequestNo': 'リクエスト番号',
        //CASP
        'VFASPID': 'CASP ID',
        'ClientName': '名前',
        //User Balance
        'Currency': '通貨',
        'Balance': '残高',
        'LastUpdated': '最終更新日',
        //Cash Transaction
        'DateReceived': '受取日',
        'BankReference': '銀行参照',
        'ErrorMessage': 'エラー',
        //Error
        'ServerError': 'エラー！ カスタマーサポートに連絡してください',

        //Signup
        'Signup-Title': '新しいアカウント',
        'FirstName': '名前',
        'LastName': '姓前',
        'EmailAddress': 'Eメール',
        'RepeatPassword': '確認用パスワード',
        'PromotionalCode': 'プロモーションコード',
        'SignUp': 'サインアップ',
        'Login': 'ログイン',
        'Send': '送信',
        'AlreadyMember': 'Already a member?',
        'SignUpSuccess-Message1': 'お申込みいただきありがとうございます。',
        'SignUpSuccess-Message2': 'ご入力いただきましたメールアドレスにアカウント登録用URLを送信いたしました。登録用URLをクリックしメールアドレスの認証をしてください。',
        'SignUpSuccess-Message3': 'Download Google Authenticator App on your Android or IOS device and install. Once installed scan the below code.',
        'SignUpSuccess-Message4': 'After Scan is complete',

        // Tranche
        'TrancheID': 'トランシェID',
        'TrancheName': 'トランシェ名',
        'Token': 'トークン',
        'TokenReleased': 'トークンリリース',
        'TrancheRate': 'レート',
        'PendingOrders': '保留中の注文',
        'PendingBonus': '保留中のボーナス',
        'TokenRemaining': 'トークン残り',
        'TokenSold': 'トークン販売',
        'Bonus': 'ボーナス',
        'FounderReserve': 'ファウンダーリザーブ',
        'StartDate': '開始日',
        'EndDate': '終了日',

        //Cash Transacton        
        'CashTransactionType': '入出金区分',
        'ReceivedDate': '受信日',
        'ProcessDate': '処理日',
        'Amount': '金額',
        'ProcessStatus': 'ステータス',
        'TransactionID': '取引番号',
        'TransferNote': 'コメント',
        'ModifiedDate': '更新日',
        'ProcessedDate': '処理日',
        'ProcessByUser': '処理者',
        'Deposit': '入金',
        'Withdraw': '出金',
        'Cash': '現金',
        'CreditCard': 'カード',

        //Transaction
        'TransactionStatus': '取引状況',
        'BuySell': '売買',
        'Tokens': '数量',
        'UnitPrice': 'レート',
        'Buy': '買',
        'Sell': '売',
        'Transaction-Buy': '買',
        'Transaction-Sell': '売',
        'Transaction-Gift': '譲渡',
        'Transaction-Bonus': 'ボーナス',
        'From': '相手方 or カウンターパーティー',
        'To': '相手方',
        'From-bids': '販売者',
        'Txn-Completed': '取引完了',
        'Txn-Pending': '保留中',
        'Txn-Progress': '取引中',
        'Txn-Cancelled': 'キャンセル',
        'Txn-Declined': '取引不成立',
        'Txn-Expired': '期限切れ',
        'Txn-Error': 'エラー',
        'Quantity': '数量',
        'DateTime': '日時（MLT）',
        'Commission': '手数料',
        'GasFee': 'ガス料金',
        'EstimatedGasFee': '推定ガス料金',
        'Currency-Euro': 'ユーロ',
        'Currency-Bitcoin': 'ビットコイン',
        'FromWalletID': '相手方 or カウンターパーティー',
        'ToWalletID': '相手方',
        'BlockchainTransactionID': 'Kadena Transaction ID',
        'BlockchainRequestKey': 'Kadena Request Key',
        'Suspicious': '疑わしい',
        'Status-Requested': 'リクエスト',
        'Status-Rejected': '拒否',
        'Status-Approved': '承認',
        'UserDetails': 'ユーザー詳細',
        'PaymentType': '支払方法',
        'AGATHA-Token-Balance': '保有AGATHA数量',
        'Order-Quantity': '注文数',
        'Payment-Amount': '支払額',
        'Partial-Order': '分割購入',
        'public-purchase-price': '公開買取価格',
        'To-Confirm-Page': '確認画面へ',
        'Rate': 'レート',

        //Commission
        'OrderType-Open': '新規',
        'OrderType-Settlement': '決済',
        'CommissionCalcType': 'Calc Type',
        'CommissionCalcType-Quantity': '数量別',
        'CommissionCalcType-Percentage': '割合別',

        //Log
        'LoginDate': 'ログイン時間',
        'LogoutDate': 'ログアウト時間',
        'LoginStatus': 'ログインステータス',
        'LogoutType': 'ログアウトタイプ',
        'IPAddress': 'IPアドレス',

        //Access Rights
        'PageName': 'ページ名',
        'ReadAccess': '読込',
        'WriteAccess': '書込',
        'DeleteAccess': '削除',
        'ImportAccess': 'インポート',
        'ExportAccess': 'エクスポート',
        'VerifyAccess': '確認',
        'ApprovalAccess': '承認',
        'SelectAll': '全て',

        /*'Menu-BuyTokens': 'トークンを買う',
        'Menu-IVAFO': 'IVFAO',
        'Menu-OTCBuy-Open': 'OTC 買',
        'Menu-OTCBuy-Settlement': 'OTC 買',
        'Menu-OTCSell-Open': 'OTC 売',
        'Menu-OTCSell-Settlement': 'OTC 売',
        'Menu-OTCList': 'OTC注文一覧',
        'Menu-Statement': '入出金履歴',
        'Menu-Account': 'アカウント管理',
        'Menu-KYCApplication': '本人確認情報提出',
        'Menu-AccountDetail': '登録情報確認・変更',
        'Menu-WithdrawBankAccount': '出金先口座確認・変更',
        'Menu-Notification': '通知設定',
        'Menu-WalletAddress': 'ウォレットアドレス',
        'Menu-ReferralCode': '紹介コード',
        'Title-Deposit': '入金先口座',
        'Menu-Bitcoin-Transfer': 'ビットコイン送金',
        'Menu-BitCoinApplication': 'ビットコインウォレット申請',
        'Title-WithdrawAccount': '出金先口座情報',
        'Title-PromoterApplication': 'プログレス アソシエーター申請フォーム',
        'Title-PromoterCoupon': '紹介コード登録フォーム',
        'Title-SellTokens-Settlement': 'OTC買う注文一覧',*/
    },
};
